/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AnexoDoExameEnviadoResponse,
  AtualizarExameDto,
  CriarExameDto,
  ErroResponse,
  ExameResponse,
  ExamesControllerEnviarAnexoBody,
  ExamesControllerLaudoEspecialPdfParams,
  ExamesControllerListarParams,
  ExtracaoDeExameResponse,
  ExtrairExameExternoDto,
  LancarResultadosDto,
  LaudoEspecialResponse,
  PaginaDeExamesResponse,
  RegistrarExameExternoDto,
  SubstituirResultadosExternosDto,
  UrlDoAnexoResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getExamesControllerListarUrl = (params?: ExamesControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/exames?${stringifiedParams}` : `/v1/exames`
}

/**
 * @summary Lista os exames. Devolve `examesDesde` junto — o corte a partir do qual o laboratório é importado.
 */
export const examesControllerListar = async (params?: ExamesControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeExamesResponse> => {

  return httpClient<PaginaDeExamesResponse>(getExamesControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExamesControllerListarQueryKey = (params?: ExamesControllerListarParams,) => {
    return [
    `/v1/exames`, ...(params ? [params] : [])
    ] as const;
    }


export const getExamesControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof examesControllerListar>>, TError = ErroResponse>(params?: ExamesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExamesControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof examesControllerListar>>> = ({ signal }) => examesControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof examesControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExamesControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof examesControllerListar>>>
export type ExamesControllerListarQueryError = ErroResponse


export function useExamesControllerListar<TData = Awaited<ReturnType<typeof examesControllerListar>>, TError = ErroResponse>(
 params: undefined |  ExamesControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof examesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof examesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamesControllerListar<TData = Awaited<ReturnType<typeof examesControllerListar>>, TError = ErroResponse>(
 params?: ExamesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof examesControllerListar>>,
          TError,
          Awaited<ReturnType<typeof examesControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamesControllerListar<TData = Awaited<ReturnType<typeof examesControllerListar>>, TError = ErroResponse>(
 params?: ExamesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os exames. Devolve `examesDesde` junto — o corte a partir do qual o laboratório é importado.
 */

export function useExamesControllerListar<TData = Awaited<ReturnType<typeof examesControllerListar>>, TError = ErroResponse>(
 params?: ExamesControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExamesControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getExamesControllerCriarUrl = () => {




  return `/v1/exames`
}

/**
 * @summary Lança um exame MANUAL. O corte por data não se aplica aqui — ele vale para o sync do laboratório.
 */
export const examesControllerCriar = async (criarExameDto: CriarExameDto, options?: Parameters<typeof httpClient>[1]): Promise<ExameResponse> => {

  return httpClient<ExameResponse>(getExamesControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarExameDto)
  }
);}





export const getExamesControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerCriar>>, TError,{data: CriarExameDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof examesControllerCriar>>, TError,{data: CriarExameDto}, TContext> => {

const mutationKey = ['examesControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examesControllerCriar>>, {data: CriarExameDto}> = (props) => {
          const {data} = props ?? {};

          return  examesControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExamesControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof examesControllerCriar>>>
    export type ExamesControllerCriarMutationBody = CriarExameDto
    export type ExamesControllerCriarMutationError = ErroResponse

    /**
 * @summary Lança um exame MANUAL. O corte por data não se aplica aqui — ele vale para o sync do laboratório.
 */
export const useExamesControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerCriar>>, TError,{data: CriarExameDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examesControllerCriar>>,
        TError,
        {data: CriarExameDto},
        TContext
      > => {
      return useMutation(getExamesControllerCriarMutationOptions(options), queryClient);
    }
    export const getExamesControllerObterUrl = (id: string,) => {




  return `/v1/exames/${id}`
}

/**
 * @summary Detalha um exame com todos os resultados e faixas
 */
export const examesControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<ExameResponse> => {

  return httpClient<ExameResponse>(getExamesControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExamesControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/exames/${id}`
    ] as const;
    }


export const getExamesControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof examesControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExamesControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof examesControllerObter>>> = ({ signal }) => examesControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof examesControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExamesControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof examesControllerObter>>>
export type ExamesControllerObterQueryError = ErroResponse


export function useExamesControllerObter<TData = Awaited<ReturnType<typeof examesControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof examesControllerObter>>,
          TError,
          Awaited<ReturnType<typeof examesControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamesControllerObter<TData = Awaited<ReturnType<typeof examesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof examesControllerObter>>,
          TError,
          Awaited<ReturnType<typeof examesControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamesControllerObter<TData = Awaited<ReturnType<typeof examesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um exame com todos os resultados e faixas
 */

export function useExamesControllerObter<TData = Awaited<ReturnType<typeof examesControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExamesControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getExamesControllerAtualizarUrl = (id: string,) => {




  return `/v1/exames/${id}`
}

/**
 * @summary Edita status, O.S., datas e observações
 */
export const examesControllerAtualizar = async (id: string,
    atualizarExameDto: AtualizarExameDto, options?: Parameters<typeof httpClient>[1]): Promise<ExameResponse> => {

  return httpClient<ExameResponse>(getExamesControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarExameDto)
  }
);}





export const getExamesControllerAtualizarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerAtualizar>>, TError,{id: string;data: AtualizarExameDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof examesControllerAtualizar>>, TError,{id: string;data: AtualizarExameDto}, TContext> => {

const mutationKey = ['examesControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examesControllerAtualizar>>, {id: string;data: AtualizarExameDto}> = (props) => {
          const {id,data} = props ?? {};

          return  examesControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExamesControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof examesControllerAtualizar>>>
    export type ExamesControllerAtualizarMutationBody = AtualizarExameDto
    export type ExamesControllerAtualizarMutationError = unknown

    /**
 * @summary Edita status, O.S., datas e observações
 */
export const useExamesControllerAtualizar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerAtualizar>>, TError,{id: string;data: AtualizarExameDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examesControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarExameDto},
        TContext
      > => {
      return useMutation(getExamesControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getExamesControllerExcluirUrl = (id: string,) => {




  return `/v1/exames/${id}`
}

/**
 * @summary Exclusão lógica. Os resultados continuam no banco.
 */
export const examesControllerExcluir = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getExamesControllerExcluirUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getExamesControllerExcluirMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof examesControllerExcluir>>, TError,{id: string}, TContext> => {

const mutationKey = ['examesControllerExcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examesControllerExcluir>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  examesControllerExcluir(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExamesControllerExcluirMutationResult = NonNullable<Awaited<ReturnType<typeof examesControllerExcluir>>>

    export type ExamesControllerExcluirMutationError = unknown

    /**
 * @summary Exclusão lógica. Os resultados continuam no banco.
 */
export const useExamesControllerExcluir = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examesControllerExcluir>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getExamesControllerExcluirMutationOptions(options), queryClient);
    }
    export const getExamesControllerLaudoEspecialUrl = (id: string,) => {




  return `/v1/exames/${id}/laudo-especial`
}

/**
 * @summary Quais laudos especiais (VitD, PTH+Cálcio, B12+Ácido Fólico) este exame tem. Lista vazia é resposta normal.
 */
export const examesControllerLaudoEspecial = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<LaudoEspecialResponse> => {

  return httpClient<LaudoEspecialResponse>(getExamesControllerLaudoEspecialUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExamesControllerLaudoEspecialQueryKey = (id: string,) => {
    return [
    `/v1/exames/${id}/laudo-especial`
    ] as const;
    }


export const getExamesControllerLaudoEspecialQueryOptions = <TData = Awaited<ReturnType<typeof examesControllerLaudoEspecial>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerLaudoEspecial>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExamesControllerLaudoEspecialQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof examesControllerLaudoEspecial>>> = ({ signal }) => examesControllerLaudoEspecial(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof examesControllerLaudoEspecial>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExamesControllerLaudoEspecialQueryResult = NonNullable<Awaited<ReturnType<typeof examesControllerLaudoEspecial>>>
export type ExamesControllerLaudoEspecialQueryError = ErroResponse


export function useExamesControllerLaudoEspecial<TData = Awaited<ReturnType<typeof examesControllerLaudoEspecial>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerLaudoEspecial>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof examesControllerLaudoEspecial>>,
          TError,
          Awaited<ReturnType<typeof examesControllerLaudoEspecial>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamesControllerLaudoEspecial<TData = Awaited<ReturnType<typeof examesControllerLaudoEspecial>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerLaudoEspecial>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof examesControllerLaudoEspecial>>,
          TError,
          Awaited<ReturnType<typeof examesControllerLaudoEspecial>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamesControllerLaudoEspecial<TData = Awaited<ReturnType<typeof examesControllerLaudoEspecial>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerLaudoEspecial>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Quais laudos especiais (VitD, PTH+Cálcio, B12+Ácido Fólico) este exame tem. Lista vazia é resposta normal.
 */

export function useExamesControllerLaudoEspecial<TData = Awaited<ReturnType<typeof examesControllerLaudoEspecial>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerLaudoEspecial>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExamesControllerLaudoEspecialQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getExamesControllerLaudoEspecialPdfUrl = (id: string,
    params: ExamesControllerLaudoEspecialPdfParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/exames/${id}/laudo-especial/pdf?${stringifiedParams}` : `/v1/exames/${id}/laudo-especial/pdf`
}

/**
 * @summary O PDF do laudo especial, renderizado pelo CRM a partir da O.S.
 */
export const examesControllerLaudoEspecialPdf = async (id: string,
    params: ExamesControllerLaudoEspecialPdfParams, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getExamesControllerLaudoEspecialPdfUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExamesControllerLaudoEspecialPdfQueryKey = (id: string,
    params?: ExamesControllerLaudoEspecialPdfParams,) => {
    return [
    `/v1/exames/${id}/laudo-especial/pdf`, ...(params ? [params] : [])
    ] as const;
    }


export const getExamesControllerLaudoEspecialPdfQueryOptions = <TData = Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>, TError = Blob>(id: string,
    params: ExamesControllerLaudoEspecialPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExamesControllerLaudoEspecialPdfQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>> = ({ signal }) => examesControllerLaudoEspecialPdf(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExamesControllerLaudoEspecialPdfQueryResult = NonNullable<Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>>
export type ExamesControllerLaudoEspecialPdfQueryError = Blob


export function useExamesControllerLaudoEspecialPdf<TData = Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>, TError = Blob>(
 id: string,
    params: ExamesControllerLaudoEspecialPdfParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>,
          TError,
          Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamesControllerLaudoEspecialPdf<TData = Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>, TError = Blob>(
 id: string,
    params: ExamesControllerLaudoEspecialPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>,
          TError,
          Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamesControllerLaudoEspecialPdf<TData = Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>, TError = Blob>(
 id: string,
    params: ExamesControllerLaudoEspecialPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary O PDF do laudo especial, renderizado pelo CRM a partir da O.S.
 */

export function useExamesControllerLaudoEspecialPdf<TData = Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>, TError = Blob>(
 id: string,
    params: ExamesControllerLaudoEspecialPdfParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerLaudoEspecialPdf>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExamesControllerLaudoEspecialPdfQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getExamesControllerCriarExternoUrl = () => {




  return `/v1/exames/externos`
}

/**
 * @summary Registra um exame que veio pronto de fora: nome livre, data, laboratório, os documentos já enviados e, se houver, os valores conferidos.
 */
export const examesControllerCriarExterno = async (registrarExameExternoDto: RegistrarExameExternoDto, options?: Parameters<typeof httpClient>[1]): Promise<ExameResponse> => {

  return httpClient<ExameResponse>(getExamesControllerCriarExternoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(registrarExameExternoDto)
  }
);}





export const getExamesControllerCriarExternoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerCriarExterno>>, TError,{data: RegistrarExameExternoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof examesControllerCriarExterno>>, TError,{data: RegistrarExameExternoDto}, TContext> => {

const mutationKey = ['examesControllerCriarExterno'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examesControllerCriarExterno>>, {data: RegistrarExameExternoDto}> = (props) => {
          const {data} = props ?? {};

          return  examesControllerCriarExterno(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExamesControllerCriarExternoMutationResult = NonNullable<Awaited<ReturnType<typeof examesControllerCriarExterno>>>
    export type ExamesControllerCriarExternoMutationBody = RegistrarExameExternoDto
    export type ExamesControllerCriarExternoMutationError = ErroResponse

    /**
 * @summary Registra um exame que veio pronto de fora: nome livre, data, laboratório, os documentos já enviados e, se houver, os valores conferidos.
 */
export const useExamesControllerCriarExterno = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerCriarExterno>>, TError,{data: RegistrarExameExternoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examesControllerCriarExterno>>,
        TError,
        {data: RegistrarExameExternoDto},
        TContext
      > => {
      return useMutation(getExamesControllerCriarExternoMutationOptions(options), queryClient);
    }
    export const getExamesControllerEnviarAnexoUrl = () => {




  return `/v1/exames/anexos`
}

/**
 * @summary Envia um documento de exame externo (PDF ou imagem) e devolve o `arquivoId`
 */
export const examesControllerEnviarAnexo = async (examesControllerEnviarAnexoBody: ExamesControllerEnviarAnexoBody, options?: Parameters<typeof httpClient>[1]): Promise<AnexoDoExameEnviadoResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, examesControllerEnviarAnexoBody.arquivo);

  return httpClient<AnexoDoExameEnviadoResponse>(getExamesControllerEnviarAnexoUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getExamesControllerEnviarAnexoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerEnviarAnexo>>, TError,{data: ExamesControllerEnviarAnexoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof examesControllerEnviarAnexo>>, TError,{data: ExamesControllerEnviarAnexoBody}, TContext> => {

const mutationKey = ['examesControllerEnviarAnexo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examesControllerEnviarAnexo>>, {data: ExamesControllerEnviarAnexoBody}> = (props) => {
          const {data} = props ?? {};

          return  examesControllerEnviarAnexo(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExamesControllerEnviarAnexoMutationResult = NonNullable<Awaited<ReturnType<typeof examesControllerEnviarAnexo>>>
    export type ExamesControllerEnviarAnexoMutationBody = ExamesControllerEnviarAnexoBody
    export type ExamesControllerEnviarAnexoMutationError = ErroResponse

    /**
 * @summary Envia um documento de exame externo (PDF ou imagem) e devolve o `arquivoId`
 */
export const useExamesControllerEnviarAnexo = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerEnviarAnexo>>, TError,{data: ExamesControllerEnviarAnexoBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examesControllerEnviarAnexo>>,
        TError,
        {data: ExamesControllerEnviarAnexoBody},
        TContext
      > => {
      return useMutation(getExamesControllerEnviarAnexoMutationOptions(options), queryClient);
    }
    export const getExamesControllerExtrairExternoUrl = () => {




  return `/v1/exames/externos/extracoes`
}

/**
 * @summary Lê um documento de exame externo com IA e devolve o que encontrou (nome, data, laboratório, valores já casados com o catálogo). Não grava o exame.
 */
export const examesControllerExtrairExterno = async (extrairExameExternoDto: ExtrairExameExternoDto, options?: Parameters<typeof httpClient>[1]): Promise<ExtracaoDeExameResponse> => {

  return httpClient<ExtracaoDeExameResponse>(getExamesControllerExtrairExternoUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(extrairExameExternoDto)
  }
);}





export const getExamesControllerExtrairExternoMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerExtrairExterno>>, TError,{data: ExtrairExameExternoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof examesControllerExtrairExterno>>, TError,{data: ExtrairExameExternoDto}, TContext> => {

const mutationKey = ['examesControllerExtrairExterno'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examesControllerExtrairExterno>>, {data: ExtrairExameExternoDto}> = (props) => {
          const {data} = props ?? {};

          return  examesControllerExtrairExterno(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExamesControllerExtrairExternoMutationResult = NonNullable<Awaited<ReturnType<typeof examesControllerExtrairExterno>>>
    export type ExamesControllerExtrairExternoMutationBody = ExtrairExameExternoDto
    export type ExamesControllerExtrairExternoMutationError = ErroResponse

    /**
 * @summary Lê um documento de exame externo com IA e devolve o que encontrou (nome, data, laboratório, valores já casados com o catálogo). Não grava o exame.
 */
export const useExamesControllerExtrairExterno = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerExtrairExterno>>, TError,{data: ExtrairExameExternoDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examesControllerExtrairExterno>>,
        TError,
        {data: ExtrairExameExternoDto},
        TContext
      > => {
      return useMutation(getExamesControllerExtrairExternoMutationOptions(options), queryClient);
    }
    export const getExamesControllerUrlDoAnexoUrl = (id: string,
    anexoId: string,) => {




  return `/v1/exames/${id}/anexos/${anexoId}/arquivo`
}

/**
 * @summary URL assinada de um documento do exame
 */
export const examesControllerUrlDoAnexo = async (id: string,
    anexoId: string, options?: Parameters<typeof httpClient>[1]): Promise<UrlDoAnexoResponse> => {

  return httpClient<UrlDoAnexoResponse>(getExamesControllerUrlDoAnexoUrl(id,anexoId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExamesControllerUrlDoAnexoQueryKey = (id: string,
    anexoId: string,) => {
    return [
    `/v1/exames/${id}/anexos/${anexoId}/arquivo`
    ] as const;
    }


export const getExamesControllerUrlDoAnexoQueryOptions = <TData = Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>, TError = ErroResponse>(id: string,
    anexoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExamesControllerUrlDoAnexoQueryKey(id,anexoId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>> = ({ signal }) => examesControllerUrlDoAnexo(id,anexoId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined && anexoId !== null && anexoId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ExamesControllerUrlDoAnexoQueryResult = NonNullable<Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>>
export type ExamesControllerUrlDoAnexoQueryError = ErroResponse


export function useExamesControllerUrlDoAnexo<TData = Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>, TError = ErroResponse>(
 id: string,
    anexoId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>,
          TError,
          Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamesControllerUrlDoAnexo<TData = Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>, TError = ErroResponse>(
 id: string,
    anexoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>,
          TError,
          Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useExamesControllerUrlDoAnexo<TData = Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>, TError = ErroResponse>(
 id: string,
    anexoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary URL assinada de um documento do exame
 */

export function useExamesControllerUrlDoAnexo<TData = Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>, TError = ErroResponse>(
 id: string,
    anexoId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof examesControllerUrlDoAnexo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getExamesControllerUrlDoAnexoQueryOptions(id,anexoId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getExamesControllerLancarResultadosUrl = (id: string,) => {




  return `/v1/exames/${id}/resultados`
}

/**
 * @summary Lança TODOS os resultados de uma vez. A interpretação é calculada no servidor e persistida; o exame vira CONCLUIDO quando não falta analito.
 */
export const examesControllerLancarResultados = async (id: string,
    lancarResultadosDto: LancarResultadosDto, options?: Parameters<typeof httpClient>[1]): Promise<ExameResponse> => {

  return httpClient<ExameResponse>(getExamesControllerLancarResultadosUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(lancarResultadosDto)
  }
);}





export const getExamesControllerLancarResultadosMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerLancarResultados>>, TError,{id: string;data: LancarResultadosDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof examesControllerLancarResultados>>, TError,{id: string;data: LancarResultadosDto}, TContext> => {

const mutationKey = ['examesControllerLancarResultados'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examesControllerLancarResultados>>, {id: string;data: LancarResultadosDto}> = (props) => {
          const {id,data} = props ?? {};

          return  examesControllerLancarResultados(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExamesControllerLancarResultadosMutationResult = NonNullable<Awaited<ReturnType<typeof examesControllerLancarResultados>>>
    export type ExamesControllerLancarResultadosMutationBody = LancarResultadosDto
    export type ExamesControllerLancarResultadosMutationError = ErroResponse

    /**
 * @summary Lança TODOS os resultados de uma vez. A interpretação é calculada no servidor e persistida; o exame vira CONCLUIDO quando não falta analito.
 */
export const useExamesControllerLancarResultados = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerLancarResultados>>, TError,{id: string;data: LancarResultadosDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examesControllerLancarResultados>>,
        TError,
        {id: string;data: LancarResultadosDto},
        TContext
      > => {
      return useMutation(getExamesControllerLancarResultadosMutationOptions(options), queryClient);
    }
    export const getExamesControllerSubstituirResultadosExternosUrl = (id: string,) => {




  return `/v1/exames/${id}/resultados-externos`
}

/**
 * @summary Substitui TODOS os valores de um exame externo — os ligados a analito e os sem analito. Lista vazia remove todos.
 */
export const examesControllerSubstituirResultadosExternos = async (id: string,
    substituirResultadosExternosDto: SubstituirResultadosExternosDto, options?: Parameters<typeof httpClient>[1]): Promise<ExameResponse> => {

  return httpClient<ExameResponse>(getExamesControllerSubstituirResultadosExternosUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(substituirResultadosExternosDto)
  }
);}





export const getExamesControllerSubstituirResultadosExternosMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerSubstituirResultadosExternos>>, TError,{id: string;data: SubstituirResultadosExternosDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof examesControllerSubstituirResultadosExternos>>, TError,{id: string;data: SubstituirResultadosExternosDto}, TContext> => {

const mutationKey = ['examesControllerSubstituirResultadosExternos'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof examesControllerSubstituirResultadosExternos>>, {id: string;data: SubstituirResultadosExternosDto}> = (props) => {
          const {id,data} = props ?? {};

          return  examesControllerSubstituirResultadosExternos(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ExamesControllerSubstituirResultadosExternosMutationResult = NonNullable<Awaited<ReturnType<typeof examesControllerSubstituirResultadosExternos>>>
    export type ExamesControllerSubstituirResultadosExternosMutationBody = SubstituirResultadosExternosDto
    export type ExamesControllerSubstituirResultadosExternosMutationError = ErroResponse

    /**
 * @summary Substitui TODOS os valores de um exame externo — os ligados a analito e os sem analito. Lista vazia remove todos.
 */
export const useExamesControllerSubstituirResultadosExternos = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof examesControllerSubstituirResultadosExternos>>, TError,{id: string;data: SubstituirResultadosExternosDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof examesControllerSubstituirResultadosExternos>>,
        TError,
        {id: string;data: SubstituirResultadosExternosDto},
        TContext
      > => {
      return useMutation(getExamesControllerSubstituirResultadosExternosMutationOptions(options), queryClient);
    }
